import React from "react";

export function Skeleton({ className = "" }) {
    return <div className={`skeleton ${className}`} />;
}

export function TableSkeleton({ rows = 5, columns = 4 }) {
    return (
        <div className="animate-pulse">
            <div className="border-b border-slate-100 px-5 py-3 dark:border-slate-800">
                <div className="grid gap-4" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
                    {[...Array(columns)].map((_, i) => (
                        <Skeleton key={i} className="h-3.5 w-20" />
                    ))}
                </div>
            </div>
            <div className="divide-y divide-slate-100 dark:divide-slate-800">
                {[...Array(rows)].map((_, row) => (
                    <div key={row} className="px-5 py-4">
                        <div className="grid gap-4" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
                            {[...Array(columns)].map((_, col) => (
                                <Skeleton key={col} className="h-4 w-full" />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export function CardSkeleton() {
    return (
        <div className="rounded-2xl border border-slate-200/80 bg-white p-5 dark:border-slate-800 dark:bg-slate-900">
            <div className="flex items-start justify-between">
                <div className="flex-1">
                    <Skeleton className="h-3.5 w-24" />
                    <Skeleton className="mt-3 h-7 w-32" />
                </div>
                <Skeleton className="h-10 w-10 rounded-xl" />
            </div>
            <Skeleton className="mt-4 h-3.5 w-20" />
        </div>
    );
}

export function ChartSkeleton() {
    return (
        <div className="rounded-2xl border border-slate-200/80 bg-white p-5 dark:border-slate-800 dark:bg-slate-900">
            <Skeleton className="h-5 w-36" />
            <Skeleton className="mt-2 h-3.5 w-24" />
            <div className="mt-6 flex h-56 items-end justify-around gap-3">
                {[...Array(7)].map((_, i) => (
                    <Skeleton key={i} className="w-8 rounded-t-lg" style={{ height: `${Math.random() * 120 + 40}px` }} />
                ))}
            </div>
        </div>
    );
}

export default function LoadingSkeleton({ type = "table", ...props }) {
    switch (type) {
        case "card":
            return <CardSkeleton {...props} />;
        case "chart":
            return <ChartSkeleton {...props} />;
        default:
            return <TableSkeleton {...props} />;
    }
}
